<template>
  <div
    class="align-center d-flex flex-column-reverse vertical-chip"
    :class="
      displayQuantity ? 'background-primary-color' : 'background-color-seashell'
    "
  >
    <v-btn @click.stop="less" :disabled="!displayQuantity" fab x-small>
      <v-icon>mdi-minus</v-icon>
    </v-btn>
    <div
      :class="displayQuantity ? 'color-white' : 'color-black-magic'"
      class="font-size-sm quantity-display-width text-center"
    >
      {{ displayQuantity }}
    </div>
    <v-btn fab x-small @click.stop="more" :disabled="exceededMax">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "QuantityButton",
  props: {
    displayQuantity: Number,
    less: Function,
    more: Function,
    exceededMax: Boolean,
  },
};
</script>
